var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"min-height":"100vh"}},[(_vm.design != null)?_c('post-view',{attrs:{"post":_vm.design}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }